import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundErrorComponent } from '../error-page/not-found-error/not-found-error';
import { ServiceDefinitionComponent } from './service-definition.component';
import { TenantSolutionsComponent } from './tenant-solutions/tenant-solutions.component';
import { ChooseCapabilityComponent } from './choose-capability/choose-capability.component';
import { ServiceDefComponent } from './service-def/service-def.component';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionGuard } from 'src/app/services/util/permission.guard';


const routes: Routes = [{
  path: '',
  component: ServiceDefinitionComponent,
  title: 'Tenant Blueprints',
  children: []
}, {
  path: 'solutions',
  component: TenantSolutionsComponent
}, {
  path: 'solutions/:solutionId',
  component: ChooseCapabilityComponent
},
{
  path: 'solutions/:solutionId/extend/:blueprintId',
  component: ChooseCapabilityComponent
}, {
  path: 'solutions/:solutionId/:latestVersion/definition',
  component: ServiceDefComponent
  },
  {
    path: 'solutions/:solutionId/:latestVersion/definition/extend/:blueprintId',
    component: ServiceDefComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceDefinitionRoutingModule { }
